export default function InfoModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[1000] p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="bg-background rounded-3xl max-w-2xl w-full max-h-[85vh] overflow-y-auto shadow-2xl border border-border/50"
        onClick={(e) => e.stopPropagation()}
        style={{ animation: 'scaleIn 300ms ease-out' }}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-5 border-b border-border/50 sticky top-0 bg-background/95 backdrop-blur-sm rounded-t-3xl">
          <h2 className="text-2xl font-bold">معلومات حول النظام</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150 text-2xl"
            aria-label="إغلاق"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 text-foreground leading-[1.7] space-y-6 text-[15px]">
          <p>
            مرحباً بك في البيئة التجريبية لـ <strong>AIlex</strong>. يتيح لك النظام إجراء محادثات تفاعلية للحصول على
            إجابات إرشادية حول القوانين الجزائرية ضمن المحتوى المتوفر في قاعدة بياناتنا.
          </p>

          <div>
            <h3 className="font-semibold text-lg mb-3">ماذا يقدّم لك النظام؟</h3>
            <ul className="list-disc list-inside space-y-2 pr-6">
              <li>محادثة تفاعلية لطرح الأسئلة القانونية والحصول على إجابات إرشادية.</li>
              <li>
                تزويدك بـ <strong>مراجع</strong> (مواد/نصوص ذات صلة) من قاعدة بياناتنا لمساعدتك على الرجوع للمصدر.
              </li>
              <li>واجهة استخدام بسيطة وسريعة.</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-3">نطاق التغطية (القوانين المتاحة)</h3>
            <ul className="list-disc list-inside space-y-2 pr-6">
              <li>
                القوانين المتاحة هي ما هو موجود حالياً في قاعدة البيانات، ويتم عرضها وتحديثها عبر الصفحة التالية:
                <a
                  href="http://law.ailex.aixpr.com/laws-list"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary underline mx-1"
                >
                  قائمة القوانين المتاحة
                </a>
              </li>
              <li>قد تتغير التغطية بإضافة/تحديث المحتوى دون إشعار مسبق خلال فترة الاختبار.</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-3">حدود الاستخدام والخطة</h3>
            <ul className="list-disc list-inside space-y-2 pr-6">
              <li>
                عند الوصول إلى <strong>حدود خطتك</strong> سيتم <strong>حظر الاستخدام</strong> إلى حين تجديد/ترقية الخطة.
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-3">سياسة المحتوى والخصوصية</h3>
            <ul className="list-disc list-inside space-y-2 pr-6">
              <li>نطبّق فلترة مسبقة للمدخلات غير اللائقة أو غير المناسبة.</li>
              <li>
                تكرار هذا السلوك قد يؤدي إلى <strong>تقييد أو حظر</strong> الحساب.
              </li>
              <li>
                نحن لا نستخدم بياناتك ولا نشاركها مع أطراف خارجية.
                قد يتم تمرير بعض البيانات بشكل تقني إلى مزوّدي خدمة موثوقين
                <strong>دون تخزينها أو استخدامها</strong>.
                ومع ذلك، نوصي بعدم إدخال أي <u>بيانات شخصية أو حساسة</u>
                (مثل رقم الهوية، العنوان، أو المعلومات البنكية).
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-3">كيفية الاستخدام</h3>
            <ul className="list-disc list-inside space-y-2 pr-6">
              <li>اكتب سؤالك في مربع النص أسفل الشاشة.</li>
              <li>اضغط “إرسال” أو Enter لإرسال الرسالة.</li>
              <li>لإضافة سطر جديد بدون إرسال استخدم Shift+Enter.</li>
              <li>يمكنك بدء محادثة جديدة بالنقر على “محادثة جديدة”.</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-3">تواصل</h3>
            <ul className="list-disc list-inside pr-6">
              <li>
                البريد الإلكتروني:{' '}
                <a href="mailto:contact-ailex@aixpr.com" className="text-primary underline">
                  contact-ailex@aixpr.com
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center pt-5 border-t border-border/50">
            <button
              onClick={onClose}
              className="px-6 py-2.5 bg-primary text-primary-foreground rounded-2xl hover:bg-primary/90 active:scale-95 transition-all duration-150 font-semibold shadow-md"
            >
              فهمت
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
